/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["label[_ngcontent-%COMP%]{margin-bottom:0;margin-left:8px}.icono[_ngcontent-%COMP%]{padding:0}.container-icono[_ngcontent-%COMP%]{width:8%;text-align-last:center}.sub-element[_ngcontent-%COMP%]{margin-left:2%}"];
export { styles as styles };
